module.exports = __webpack_public_path__ + "images/absent.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/absent.png
 ** module id = 48
 ** module chunks = 1
 **/